import { readGlobal } from 'oasis-os-common';
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { DeeplinkProps } from '../../types';

export function Deeplink({
  config,
}: DeeplinkProps) {
  let deeplink = sessionStorage.getItem('link');
  const {
    type: deeplinkType = 'route',
    name: deeplinkFeatName = undefined,
    splitCheck: deeplinkSplitCheck = false,
  } =
  readGlobal('$.global.value.functionalConfig.features.deeplink') as {
    type: 'route' | 'dispatch' | 'both',
    name: string,
    splitCheck: boolean,
  } ?? {
    type: 'route',
    name: undefined,
    splitCheck: false,
  };
  useEffect(() => {
    if (deeplink && (deeplinkType === 'dispatch' || deeplinkType === 'both')) {
      if (deeplinkSplitCheck) {
        const [featureName, id] = deeplink.split('/');
        deeplink = !!id && featureName === deeplinkFeatName ? id : deeplink;
      }
  
      sessionStorage.setItem('link', JSON.stringify({
        action: config?.deeplinkDispatch?.action,
        param: deeplink,
      }));
    }
  }, [deeplinkType]);

  if (deeplink && (deeplinkType === 'route' || deeplinkType === 'both')) {
    if (deeplinkSplitCheck) {
      const [featureName, id] = deeplink.split('/');
      deeplink = !!id && featureName === deeplinkFeatName ? id : deeplink;
    }
    return (
      <Redirect
        to={
          config?.deeplinkRoute?.includes(deeplink)
            ? deeplink
            : config?.redirectPath ?? { pathname: '/' }
        }
      />
    );
  }
  if (config?.deeplinkDispatch?.defaultRedirect) {
    return <Redirect to={config?.redirectPath ?? { pathname: '/' }} />;
  }
  return null;
}
